"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var reselect_1 = require("reselect");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var FilterPanelToggleButton_1 = require("../components/FilterPanel/FilterPanelToggleButton");
var ConnectToDialogStyles_1 = require("../style/ConnectToDialogStyles");
var ConnectToDialogTopPanel = /** @class */ (function (_super) {
    __extends(ConnectToDialogTopPanel, _super);
    function ConnectToDialogTopPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.dataTypesForNoCatalog = [
            { value: 'Datasources', content: Localize_1.Messages.Datasources() }
        ];
        _this.dataTypesForExistingDS = [
            { value: 'Databases', content: Localize_1.Messages.DatabasesAndFiles() },
            { value: 'Tables', content: Localize_1.Messages.Tables() }
        ];
        _this.dataTypesForNewDS = [
            { value: 'Datasources', content: Localize_1.Messages.Datasources() },
            { value: 'Databases', content: Localize_1.Messages.DatabasesAndFiles() },
            { value: 'Tables', content: Localize_1.Messages.Tables() }
        ];
        _this.memoizedDataTypeListItems = reselect_1.defaultMemoize(function () {
            // workaround to hide datasources from viewer site roles
            if (!_this.props.roleAllowsViewingDatasources) {
                return (_this.props.isCatalogingEnabled && !_this.props.showDatasourceOnly) ? _this.dataTypesForExistingDS : [];
            }
            else if (_this.props.showDatasourceOnly || !_this.props.isCatalogingEnabled) {
                return _this.props.isNewDatasource ? _this.dataTypesForNoCatalog : [];
            }
            else {
                return _this.props.isNewDatasource ? _this.dataTypesForNewDS : _this.dataTypesForExistingDS;
            }
        });
        _this.state = { totalCount: null };
        return _this;
    }
    ConnectToDialogTopPanel.prototype.getSelectedDataTypeString = function (dataType) {
        switch (dataType) {
            case 'Databases':
                return this.props.totalCountDatabase != null ?
                    Localize_1.Messages.DatabasesAndFilesWithCount({ count: this.props.totalCountDatabase.toString() }) : Localize_1.Messages.DatabasesAndFiles();
            case 'Datasources':
                return this.props.totalCountDatasource != null ?
                    Localize_1.Messages.DatasourcesWithCount({ count: this.props.totalCountDatasource.toString() }) : Localize_1.Messages.Datasources();
            case 'Tables':
                return this.props.totalCountTable != null ?
                    Localize_1.Messages.TablesWithCount({ count: this.props.totalCountTable.toString() }) : Localize_1.Messages.Tables();
            default:
                return '';
        }
    };
    ConnectToDialogTopPanel.prototype.getDataTypeSelectionDropDown = function () {
        // Do not show the dropdown if we are showing only 1 or less dataType
        if (!this.props.isCatalogingEnabled || this.props.showDatasourceOnly) {
            return null;
        }
        var listProps = {
            items: this.memoizedDataTypeListItems(),
            onSelect: this.props.onDataTypeChange,
            selectOnEnterKey: true,
            selectedValue: this.props.selectedDataType,
            testId: 'connect-to-data-type-list',
        };
        return (React.createElement("div", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDropdown) },
            React.createElement(widgets_1.SingleSelectDropdown, { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDropdownButton), type: widgets_1.DropdownButtonType.Line, label: '', list: React.createElement(widgets_1.List, __assign({}, listProps)), value: this.getSelectedDataTypeString(this.props.selectedDataType), onChange: this.props.onDataTypeChange, testId: 'connect-to-data-type-dropdown', stackingRootId: 'connect-to-dialog-tool-bar-stacking-root' }),
            React.createElement("span", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDropdownLabel) }, Localize_1.Messages.ConnectToDropdownLabelText())));
    };
    ConnectToDialogTopPanel.prototype.getFilterPanelToggleButton = function () {
        if (!this.props.isFilterPanelAvailable) {
            return null;
        }
        return (React.createElement("span", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToFilterPanelToggleButton) },
            React.createElement(FilterPanelToggleButton_1.FilterPanelToggleButton, { filtersApplied: this.props.filtersApplied, filterPanelButtonClickHandler: this.props.onToggleFilter, disabled: false })));
    };
    ConnectToDialogTopPanel.prototype.render = function () {
        return (React.createElement("div", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDialogToolBar) },
            React.createElement("div", { id: 'connect-to-dialog-tool-bar-stacking-root', className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDialogToolBarStackingRoot) }),
            React.createElement(widgets_1.TextFieldWidget, { "aria-label": Localize_1.Messages.SearchLabel(), kind: 'search', label: '', onClear: this.props.clearSearch, onChange: this.props.updateSearchText, onKeyDown: this.props.onKeyDown, placeholder: Localize_1.Messages.SearchFieldPlaceholder(), style: ConnectToDialogStyles_1.ConnectToSearchFieldContainerStyle, testId: 'connect-to-search-field', value: this.props.inProgressSearchText }),
            this.getFilterPanelToggleButton(),
            this.getDataTypeSelectionDropDown()));
    };
    return ConnectToDialogTopPanel;
}(React.PureComponent));
exports.ConnectToDialogTopPanel = ConnectToDialogTopPanel;
//# sourceMappingURL=ConnectToDialogTopPanel.js.map